import Vue3Lottie from 'vue3-lottie'

export default {
  install: (app) => {
    app.use(Vue3Lottie, { name: 'LottieAnimation' })
  },
}
